<div role="dialog" aria-labelledby="modalTableDataTitle" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalTableDataTitle">{{ messageStatus.message }}</h4>
        <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
      </div>
      <div class="modal-body">
        @if (pager.total > 0) {
        <div class="col-xs-12 input-trend-search">
          <input #searchBox type="search" class="form-control" placeholder="Pesquisar..."
            (input)="onSearch(searchBox.value)" (keyup)="onSearch(searchBox.value)" />
          <span class="mdi mdi-magnify search-icon"></span>
        </div>
        }

        @if(loadingSpinner$ | async) {
        <loading-component />
        }

        @if (!(loadingSpinner$ | async) && pager.total > 0) {
        <div class="card-body table-responsive">
          <table class="table table-hover table-centered mb-0">
            <thead>
              <tr>
                <th class="text-primary-emphasis">Status</th>
                <th class="text-primary-emphasis">Cliente</th>
                <th class="text-primary-emphasis">Canal</th>
                <th class="text-primary-emphasis">Departamento</th>
                @if (data.status === 'CLOSED') {
                  <th class="text-primary-emphasis">TME/TMA/TMTA</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (item of pager.list; track $index) {
              <tr>
                <td>
                  @switch (item?.status) {
                  @case ('CLOSED') {
                  <span class="mx-1 px-1 badge font-14 text-bg-danger rounded-lg">
                    Fechado
                  </span>
                  }
                  @case ('OVERTIME') {
                  <span class="mx-1 px-1 badge font-14 text-bg-info rounded-lg">
                    Fora do horário
                  </span>
                  }
                  @case ('PENDING') {
                  <span class="mx-1 px-1 badge font-14 text-bg-warning rounded-lg">
                    Aguardando
                  </span>
                  }
                  @case ('PAUSED') {
                  <span class="mx-1 px-1 badge font-14 text-bg-light rounded-lg">
                    Pausado
                  </span>
                  }
                  @default {
                  <span class="mx-1 px-1 badge font-14 text-bg-success rounded-lg">
                    Em andamento
                  </span>
                  }
                  }
                </td>
                <td>{{ item?.contact?.name }}</td>
                <td>{{item?.channel?.name}}</td>
                <td>{{item?.department?.name}}</td>
                @if (data.status === 'CLOSED') {
                <td>
                  <span matTooltip="TME">{{ getFormatKpis($safeNavigationMigration(item?.kpis?.tme)) ?? "-" }}</span> /
                  <span matTooltip="TMA">{{ getFormatKpis($safeNavigationMigration(item?.kpis?.tma)) ?? "-" }}</span> /
                  <span matTooltip="TMTA">{{ getFormatKpis($safeNavigationMigration(item?.kpis?.tmta)) ?? "-" }}</span>
                </td>
                }
              </tr>
              }
            </tbody>
          </table>

          @if (pager.total > pager.perPage) {
          <paginator [pager]="pager" (onPager)="loadPage($event)" />
          }
        </div>
        }

        @if (pager.total == 0) {
        <empty-records-component icon="ri-message-3-line" message="Você não tem {{ messageStatus.message }}" />
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [mat-dialog-close]="true">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>